<template>
  <div class="member-badge" :class="classes">
    <div class="avatar">
      <img v-if="avatar" :src="avatar" :alt="`${safeDisplayName} profile image`" />
      <span v-else-if="!avatar" class="avatar-placeholder demi">
        {{ safeDisplayName.charAt(0) }}
      </span>
    </div>
    <div class="screen-name">
      {{ safeDisplayName }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    displayName: string
    avatar?: string
    classes?: string
  }>(),
  {
    avatar: '',
    classes: '',
  },
)

/** COMPUTED */
const safeDisplayName = computed(() => {
  // if user is null (which it shouldn't be, but technically it could via API)
  // set displayName to Unknown.  This also handles the Avatar image/first letter
  return props.displayName || 'Unknown'
})
</script>
